import { render } from "./PortfolioCard.vue?vue&type=template&id=f341fc8a&scoped=true"
import script from "./PortfolioCard.vue?vue&type=script&lang=js"
export * from "./PortfolioCard.vue?vue&type=script&lang=js"

import "./PortfolioCard.vue?vue&type=style&index=0&id=f341fc8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f341fc8a"]])

export default __exports__